import React from 'react';
import { IconBank, IconChartLine, IconShipmentBox } from 'src/presentations/components/atom/icons';
import { StatCardData } from '../../pages/askFreya/types';

const StatCard: React.FC<StatCardData> = ({ label, value, subValue, icon }) => {
  const getIcon = () => {
    switch (icon) {
      case 'dollar':
        return <IconBank size={20} color='#F79009' />;
      case 'chart':
        return <IconChartLine size={20} color='#F04438' />;
      case 'truck':
        return <IconShipmentBox size={20} color='#7A5AF8' />;
      default:
        return <IconBank size={20} color='#F79009' />;
    }
  };

  const getBgColor = () => {
    switch (icon) {
      case 'dollar':
        return 'bg-orange-20'; // Was yellow/orange
      case 'chart':
        return 'bg-red-10'; // Was red-50
      case 'truck':
        return 'bg-neutral-10'; // Fallback as purple not in config, or could use blue-20
      default:
        return 'bg-neutral-5';
    }
  };

  return (
    <div className='flex flex-col p-16 bg-white border border-neutral-20 rounded-12 min-w-[200px] flex-1 shadow-sm'>
      <div className={`w-32 h-32 rounded-full ${getBgColor()} flex items-center justify-center mb-12`}>{getIcon()}</div>
      <div className='flex flex-col gap-4'>
        <span className='text-18 font-bold text-neutral-90'>{value}</span>
        <span className='text-12 font-medium text-neutral-50'>{label}</span>
        {subValue && <span className='text-12 text-neutral-40'>{subValue}</span>}
      </div>
    </div>
  );
};

export default StatCard;
